import React from "react";
import { Col, Row, Form } from "antd";
import ReactQuill from "react-quill";

const { Item } = Form;

const Summary = () => {
  return (
    <Row span={24}>
      <Col xs={8} md={4}>
        <h4>Summary</h4>
      </Col>
      <Col xs={24} md={20}>
        <Item name="summary">
          <ReactQuill
            name="summary"
            placeholder="A brief description about yourself"
            style={{ borderRadius: 8 }}
          />
        </Item>
      </Col>
    </Row>
  );
};

export default Summary;
